import React,{Component} from 'react';

import PropTypes from 'prop-types';


import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import HeaderCell from './GridHeaderCell';
import {orange,grey} from '@mui/material/colors';

const s:any = {
  headerrow:{
    backgroundColor: grey['200'],
  },
  headercell:{
    // borderRightStyle: 'solid',
    // borderRightColor: grey['600'],
    // borderRightWidth: '1px',
  },
  root:{
    color: 'primary.main',
    fontSize: 'typography.h6.fontSize',
  },
  active:{
    color: 'primary.light',
  },
  icon:{
    color: orange['500'],
  }
};

class GridHeader extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode:0
    };
  }

  createSortHandler = (property:any) => (event:any) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    //const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;
    const { cols, actionCols, onSelectAllClick, order, orderBy, numSelected, classes } = this.props;
    //console.log('cols:',cols);
    return (
      <TableHead>
        <TableRow sx={{...s.headerrow}}>
          <HeaderCell padding="checkbox">
            {/* <Checkbox 
              indeterminate={numSelected>1} //{numSelected > 0 && numSelected < rowCount}
              checked={numSelected===1} //{numSelected === rowCount}
              onChange={onSelectAllClick}
            /> */}
          </HeaderCell>
          {cols.map((col:any) => {
            return (
              <HeaderCell
                key={col.id}
                // numeric={row.numeric}
                padding={col.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === col.id ? order : false}
                sx={{...s.headercell}}
              >
                <Tooltip
                  title="Sort"
                  placement={col.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === col.id}
                    direction={order}
                    onClick={this.createSortHandler(col.id)}
                    classes={{root:s.root,active:s.active,icon:s.icon}}
                    slotProps={{ root:{ sx:s.root} , icon: { sx:s.icon} }}
                  >
                    {col.label}
                  </TableSortLabel>
                </Tooltip>
              </HeaderCell>
            );
          }, this)}
          {actionCols && (
            <HeaderCell padding="checkbox">
            {" "}
          </HeaderCell>
          )}
        </TableRow>
      </TableHead>
    );
  }
}

GridHeader.propTypes = {
  cols: PropTypes.array.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};


export default GridHeader;